import { Link } from "react-router-dom";
import type { Movie } from "@/types/content";

interface MovieCardProps {
  movie: Movie;
}

export default function MovieCard({ movie }: MovieCardProps) {
  return (
    <Link to={`/detail/${movie.id}`} className="group block cursor-pointer">
      <div className="relative w-full aspect-[2/3] rounded-lg overflow-hidden bg-background-200">
        <img
          src={movie.cover}
          alt={`${movie.title} 影视海报`}
          title={`${movie.title} - 蜜月TV影视推荐`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute top-2 right-2 px-2 py-0.5 rounded-md bg-accent-500 text-accent-950 text-xs font-bold">
          {movie.rating.toFixed(1)}
        </span>
        {movie.tags.length > 0 && (
          <span className="absolute bottom-2 left-2 px-2 py-0.5 rounded-md bg-secondary-900/80 text-background-50 text-[11px]">
            {movie.tags[0]}
          </span>
        )}
      </div>
      <h3 className="mt-2.5 text-sm font-semibold text-foreground-900 truncate group-hover:text-primary-700 transition-colors">
        {movie.title}
      </h3>
      <p className="text-xs text-foreground-500 mt-1 truncate">
        {[...movie.genres, String(movie.year)].join(" · ")}
      </p>
    </Link>
  );
}